import { Box } from "@mui/material";
import useWindowDimensions from "../../helpers/window";
import MessagesMobile from "./MessagesMobile";
import MessagesDesktop from "./MessagesDesktop";

const Messages = () => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  return (
    <Box className="messages">
      {isMobile ? <MessagesMobile /> : <MessagesDesktop />}
    </Box>
  );
};

export default Messages;
